module.exports = __webpack_public_path__ + "static/media/banner2.f779d4f7.png";